export default "__VITE_ASSET__8bbb0015__"